module.exports = __webpack_public_path__ + "static/media/icon-error.08042aff.svg";